import React from 'react';
import PropTypes from 'prop-types';
import { shallowEqual, useSelector } from 'react-redux';

import { IconArrowDown, IconArrowUp } from '../../assets/icon';

const TableHeadData = ({
  source, children, style, className, sortable, order, onSort
}) => {
  const {
    application: { isCoOrderHeaderFixed },
  } = useSelector((state) => ({
    application: state?.application,
  }), shallowEqual);

  const [key, direction] = order?.split(':');
  const getSortIcon = () => {
    const result = '';
    if (order) {
      if (key === source) {
        if (direction === 'desc') {
          return <IconArrowDown width={15} height={15} />;
        }
        return <IconArrowUp width={15} height={15} />;
      }
    }
    return result;
  };

  const nextDirection = direction === 'desc' ? 'asc' : 'desc';

  return (
    <th
      onClick={() => onSort(`${source}:${nextDirection}`)}
      className={`
        ${className || style || ''} 
        ${sortable ? 'hover:cursor-pointer hover:text-primary' : ''} 
        ${isCoOrderHeaderFixed ? 'sticky top-0 bg-white'
        + ' dark:bg-background-dark z-[1] shadow-card' : ''}
        px-[9px] py-[16px] uppercase text-[#A1A5B7] font-medium text-left text-[12px]
        align-middle min-w-max whitespace-nowrap
      `}
    >
      <div className={`flex flex-row items-center ${sortable ? 'justify-center' : ''}`}>
        {children}
        {sortable && getSortIcon()}
      </div>
    </th>
  );
};

TableHeadData.propTypes = {
  children: PropTypes.node,
  style: PropTypes.string,
  className: PropTypes.string,
  source: PropTypes.string,
  sortable: PropTypes.bool,
  // sticky: PropTypes.bool,
  order: PropTypes.string,
  onSort: PropTypes.func
};

TableHeadData.defaultProps = {
  children: undefined,
  style: undefined,
  className: undefined,
  source: undefined,
  sortable: false,
  // sticky: false,
  order: 'a:b',
  onSort: () => {}
};

export default TableHeadData;
